import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import type User from 'modules/core/store/models/User'

interface Props {
  filename: string
  onRemove: (...args: []) => void
  author?: User
  createdAt?: string
}

const ResultLine = ({ onRemove, filename, author, createdAt }: Props) => {
  const isUploadModal = !author
  const createdAtText = createdAt ? `${createdAt} -` : ''

  return (
    <Box
      gap="s8"
      padding="s16"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box gap="s8" flexDirection="column">
        <Box alignItems="center" flexDirection="row">
          {isUploadModal && <Icon.Medium icon="file" />}
          <Text.Normal overflowWrap size={isUploadModal ? '200' : '300'} weight="semibold">
            {filename}
          </Text.Normal>
        </Box>
        {author && (
          <Text.Normal size="200">
            {`${createdAtText} ${i18n.t('documents.uploaded_by', {
              authorName: getFullDisplayName({
                firstName: author.attributes.first_name,
                lastName: author.attributes.last_name,
              }),
            })}`}
          </Text.Normal>
        )}
      </Box>
      <Box alignSelf="center">
        <Button type="secondary" onClick={onRemove} iconName="delete" />
      </Box>
    </Box>
  )
}

export default observer(ResultLine)
